(() => {
  const KEY = 'protocol_xxvii_saved_issues_v1';
  const $all = (s, root=document) => Array.from(root.querySelectorAll(s));

  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(value) ? value.filter(x => x && x.handle) : [];
    } catch (_) { return []; }
  };
  const write = (items) => {
    localStorage.setItem(KEY, JSON.stringify(items.slice(0, 40)));
    sync();
  };
  const esc = (v='') => String(v).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[c]));

  function syncButtons(items) {
    const handles = new Set(items.map(x => x.handle));
    $all('[data-px-wishlist-toggle]').forEach(btn => {
      const active = handles.has(btn.dataset.handle);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      const label = btn.querySelector('[data-px-wishlist-label]');
      if (label) label.textContent = active ? 'SAVED' : 'SAVE ISSUE';
    });
    $all('[data-px-wishlist-open]').forEach(btn => btn.classList.toggle('is-active', items.length > 0));
    $all('[data-px-wishlist-count]').forEach(node => {
      node.textContent = String(items.length);
      node.hidden = items.length === 0;
    });
  }

  function renderDrawer(items) {
    const list = document.querySelector('[data-px-wishlist-list]');
    const empty = document.querySelector('[data-px-wishlist-empty]');
    if (!list || !empty) return;
    empty.hidden = items.length > 0;
    list.innerHTML = items.map(item => `
      <article class="px-wishlist-item">
        <a class="px-wishlist-item__media" href="${esc(item.url)}">
          ${item.image ? `<img src="${esc(item.image)}" alt="${esc(item.title)}" loading="lazy">` : ''}
        </a>
        <div class="px-wishlist-item__info">
          <a href="${esc(item.url)}">${esc(item.title)}</a>
          <span>${esc(item.price)}</span>
        </div>
        <button type="button" class="px-wishlist-item__remove" data-px-wishlist-remove="${esc(item.handle)}" aria-label="Remove ${esc(item.title)}">×</button>
      </article>
    `).join('');
  }

  function sync() {
    const items = read();
    syncButtons(items);
    renderDrawer(items);
  }

  function toggle(btn) {
    const handle = btn.dataset.handle;
    if (!handle) return;
    let items = read();
    const index = items.findIndex(x => x.handle === handle);
    if (index >= 0) {
      items.splice(index, 1);
    } else {
      items.unshift({
        handle,
        title: btn.dataset.title || '',
        url: btn.dataset.url || '',
        image: btn.dataset.image || '',
        price: btn.dataset.price || ''
      });
    }
    write(items);
  }

  function openDrawer() {
    const drawer = document.querySelector('[data-px-wishlist-drawer]');
    const overlay = document.querySelector('[data-px-wishlist-overlay]');
    if (!drawer || !overlay) return;
    sync();
    overlay.hidden = false;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('px-wishlist-open');
  }

  function closeDrawer() {
    const drawer = document.querySelector('[data-px-wishlist-drawer]');
    const overlay = document.querySelector('[data-px-wishlist-overlay]');
    if (!drawer || !overlay) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.hidden = true;
    document.body.classList.remove('px-wishlist-open');
  }

  document.addEventListener('click', (event) => {
    const toggleButton = event.target.closest('[data-px-wishlist-toggle]');
    if (toggleButton) {
      event.preventDefault();
      event.stopPropagation();
      toggle(toggleButton);
      return;
    }
    if (event.target.closest('[data-px-wishlist-open]')) {
      event.preventDefault();
      openDrawer();
      return;
    }
    if (event.target.closest('[data-px-wishlist-close]') || event.target.matches('[data-px-wishlist-overlay]')) {
      closeDrawer();
      return;
    }
    const remove = event.target.closest('[data-px-wishlist-remove]');
    if (remove) {
      const items = read().filter(x => x.handle !== remove.dataset.pxWishlistRemove);
      write(items);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDrawer();
  });

  const updateCountdowns = () => {
    $all('[data-px-countdown]').forEach(el => {
      const target = Date.parse(el.dataset.releaseAt || '');
      if (!Number.isFinite(target)) { el.hidden = true; return; }
      const diff = target - Date.now();
      const time = el.querySelector('[data-px-countdown-time]');
      const live = el.querySelector('[data-px-countdown-live]');
      if (diff <= 0) {
        if (time) time.hidden = true;
        if (live) live.hidden = false;
        return;
      }
      if (time) time.hidden = false;
      if (live) live.hidden = true;
      const total = Math.floor(diff / 1000);
      const days = Math.floor(total / 86400);
      const hours = Math.floor((total % 86400) / 3600);
      const minutes = Math.floor((total % 3600) / 60);
      const seconds = total % 60;
      const set = (selector, value) => {
        const node = el.querySelector(selector);
        if (node) node.textContent = String(value).padStart(2, '0');
      };
      set('[data-px-days]', days);
      set('[data-px-hours]', hours);
      set('[data-px-minutes]', minutes);
      set('[data-px-seconds]', seconds);
    });
  };

  sync();
  updateCountdowns();
  setInterval(updateCountdowns, 1000);

  document.addEventListener('shopify:section:load', sync);
  const main = document.querySelector('#MainContent');
  if (main && 'MutationObserver' in window) {
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; syncButtons(read()); });
    }).observe(main, {childList:true, subtree:true});
  }
})();